import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './index.css'
import { initGA } from './lib/analytics'

// Initialize Google Analytics
initGA()

// Note: Translation is now handled by the Universal Translator widget
// which is loaded via script tag in index.html

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
      <App />
  </React.StrictMode>,
)
